import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Button, Row, Col, Spinner, Form } from 'react-bootstrap';
import { InputField, SelectField } from "../../../lib/formControls";
import { uploadToS3 } from "../../../lib/appFileUpload";
import imageIcon from "../../../common/images/imageIcon.png";

const amountField = yup
  .string()
  .nullable()
  .notRequired()
  .test(
    "is-valid-amount",
    "Enter valid amount",
    (value) => {
      if (!value) return true; // ✅ allow empty
      return /^\d+(\.\d{1,2})?$/.test(value);
    }
  );

const schema = yup.object().shape({
  petrol: amountField,
  diesel: amountField,
  lpg: amountField,
  cng: amountField,
});


const FuelRateForm = ({ mode = 'add', onSubmit, initialData = {}, loading=false }) => {
  const {
  register,
  handleSubmit,
  reset,
  watch,
  setValue,
  control,
  formState: { errors, isSubmitting }
} = useForm({
  resolver: yupResolver(schema, { context: { mode } }),
  defaultValues: {
    petrol: '',
    diesel: '',
    lpg: '',
    cng: '',
  }
});

    const [file, setFile] = useState(null);
    const [fileUploading, setFileUploading] = useState(false);
    const [actiondisable, setActiondisable] = useState(true);

    const watchpetrol = watch("petrol");
    const watchdiesel = watch("diesel");
    const watchlpg = watch("lpg");
    const watchcng = watch("cng");
  
    useEffect(() => {
      if (watchpetrol || watchdiesel || watchlpg || watchcng) {
        setActiondisable(false);
      }
      if (watchpetrol === '' && watchdiesel === '' && watchlpg === '' && watchcng === '') {
        setActiondisable(true);
      }
    }, [watchpetrol, watchdiesel, watchlpg, watchcng]);

  // Prefill form in edit mode
  useEffect(() => {
    if (mode === 'edit' && initialData) {
      let fuelRateObj = (initialData?.fuelRate)?initialData?.fuelRate:{};
      Object.keys(fuelRateObj).forEach((key) => {
        setValue(key, fuelRateObj[key]);
      });
    }
  }, [mode, initialData, setValue]);


  const handleSubmitForm = (data) => {
    console.log('Submitting form data:', data);
    onSubmit(data);
  };


  return (
    <form className='fuelrate-from-main' onSubmit={handleSubmit(handleSubmitForm)}>
        
        <Row>
         <Col md={12}>
          <InputField
            label="Petrol Rate"
            name="petrol"
            type="text"
            placeholder="Petrol Rate"
            controlclass="mb-3"
            register={register}
            className="custom-input-pd"
            errors={errors}
          />
        </Col>
        </Row>

        <Row>
        <Col md={12}>
          <InputField
            label="Diesel Rate"
            name="diesel"
            type="text"
            placeholder="Diesel Rate"
            controlclass="mb-3"
            register={register}
            className="custom-input-pd"
            errors={errors}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <InputField
            label="LPG Rate"
            name="lpg"
            type="text"
            placeholder="LPG Rate"
            controlclass="form-custom-group"
            register={register}
            className="custom-input-pd"
            errors={errors}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <InputField
            label="CNG Rate"
            name="cng"
            type="text"
            placeholder="CNG Rate"
            controlclass="form-custom-group"
            register={register}
            className="custom-input-pd"
            errors={errors}
          />
        </Col>
      </Row>

      <div className="col-md-12 d-flex justify-content-between mt-auto mt-3 action-btn-buttomdiv">
        <Button variant="secondary custom-cnl-btncls" disabled={actiondisable || isSubmitting || loading} type="button" onClick={() => reset()}>
          Cancel
        </Button>
        <Button type="submit" disabled={actiondisable || isSubmitting || loading} variant="primary custom-sbm-btncls">
          {loading ? (
            <>
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
              {' '}{mode === 'edit' ? 'Updating fuelrate...' : 'Adding fuelrate...'}
            </>
          ) : (
            mode === 'edit' ? 'Update FuelRate' : 'Add FuelRate'
          )}
        </Button>
      </div>
    </form>
  );
};

export default FuelRateForm;
